<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>

    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar
          class="formCard"
          style="
            border-radius: 5px !important;
            padding-left: 0px;
            height: auto !important;
          "
          toggleable="lg"
          type="dark"
          variant="primary"
        >
          <b-navbar-brand center>{{
            $route.path == "/agentColoader/agentColoaderForm" && Type
              ? Type
              : "Agent & Co-Loader"
          }}</b-navbar-brand>

          <b-navbar-nav class="ml-auto">
            <b-nav-form
              v-if="
                $sessionsStorage.get('designation') == 'Admin' &&
                $sessionsStorage.get('nameUser') == 'Bhavneesh'
              "
            >
              <b-button
                v-if="showMain == false"
                @click="goToMain"
                size="sm"
                variant="warning"
                >Add New</b-button
              >
              <!-- <b-button
                size="sm"
                class="ml-3"
                @click="getReportsAss('All_AgentColoder_Report')"
                variant="outline-info"
                >Export as Excel</b-button
              > -->
              <b-button
                size="sm"
                class="ml-3"
                :disabled="ExcelBtnName != 'Export as Excel' ? true : false"
                @click="getReportsAss('All_AgentColoder_Report', 'Export as Excel')"
                variant="outline-info"
              >
                {{ ExcelBtnName }}
                <b-spinner
                  v-if="ExcelBtnName != 'Export as Excel'"
                  small
                  label="Small Spinner"
                ></b-spinner
              ></b-button>
              <b-button
                size="sm"
                class="ml-3"
                @click="ShowImportModal"
                variant="outline-info"
                >Import Excel</b-button
              >
            </b-nav-form>
          </b-navbar-nav>
        </b-navbar>
        <b-card class="formCard">
          <b-card-text>
            <div v-if="showMain == true">
              <b-row>
                <b-col md="3">
                  <label for="blType">Agent / CoLoader</label>
                  <model-list-select
                    :list="categoryTypeList"
                    v-model="agentColaderModel.categoryType"
                    option-value="categoryTypeVal"
                    option-text="categoryTypeTxt"
                    placeholder="Select Type"
                  ></model-list-select>
                  <!-- :isDisabled="agentColaderModel.agntColoaderId != '' ? true : false" -->
                  <span class="error" v-if="!agentColaderModel.categoryType">{{
                    categoryTypeError
                  }}</span>
                </b-col>
                <b-col md="3" v-if="agentColaderModel.categoryType == 'Agent'">
                  <label for="blType">Engagement Preference</label>
                  <model-list-select
                    :list="engagementPreferenceList"
                    v-model="agentColaderModel.engagementPreference"
                    option-value="engagementTypeVal"
                    option-text="engagementTypeTxt"
                    placeholder="Select Engagement Preference"
                  ></model-list-select>
                </b-col>
                <b-col md="3" v-if="agentColaderModel.categoryType != 'CoLoader'">
                  <label>Agent Name</label>
                  <b-form-input
                    :formatter="capitalizeAll"
                    id="agentName"
                    name="agentName"
                    v-model="agentColaderModel.agentName"
                  ></b-form-input>
                </b-col>
                <b-col md="3" v-if="agentColaderModel.categoryType == 'CoLoader'">
                  <label>CoLoader Name</label>
                  <b-form-input
                    :formatter="capitalizeAll"
                    id="coLoaderName"
                    name="coLoaderName"
                    v-model="agentColaderModel.coLoaderName"
                  ></b-form-input>
                </b-col>
                <b-col md="3">
                  <label>Contact No.</label>
                  <b-form-input
                    :formatter="capitalizeAll"
                    id="contactNumber"
                    name="contactNumber"
                    v-model="agentColaderModel.contactNumber"
                  ></b-form-input>
                </b-col>
                <b-col md="3" v-if="agentColaderModel.categoryType != 'Agent'">
                  <label>Email-Id</label>
                  <b-form-input
                    :formatter="capitalizeAll"
                    id="emailId"
                    name="emailId"
                    v-model="agentColaderModel.emailId"
                  ></b-form-input>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="3" v-if="agentColaderModel.categoryType == 'Agent'">
                  <label>Email-Id</label>
                  <b-form-input
                    :formatter="capitalizeAll"
                    id="emailId"
                    name="emailId"
                    v-model="agentColaderModel.emailId"
                  ></b-form-input>
                </b-col>
                <b-col md="3">
                  <label>Company Name</label>
                  <b-form-input
                    :formatter="capitalizeAll"
                    id="companyName"
                    name="companyName"
                    v-model="agentColaderModel.companyName"
                  ></b-form-input>
                </b-col>
                <b-col md="3" v-if="agentColaderModel.categoryType == 'Agent'">
                  <label>Country Name</label>
                  <b-form-input
                    :formatter="capitalizeAll"
                    id="countryName"
                    name="countryName"
                    v-model="agentColaderModel.countryName"
                  ></b-form-input>
                </b-col>
                <b-col md="6">
                  <label>Address</label>
                  <b-form-textarea
                    :formatter="capitalizeAll"
                    id="address"
                    name="address"
                    v-model="agentColaderModel.address"
                  ></b-form-textarea>
                </b-col>
              </b-row>
              <md-layout md-gutter class="mrgtop-button mt-3 justify-content-center">
                <!-- <md-layout md-flex="40"></md-layout> -->
                <b-button
                  variant="primary"
                  @click="addAgentColoader"
                  id="addButtonLoader"
                  >{{ agentColaderModel.agntColoaderId != "" ? "Edit" : "Add" }}</b-button
                >
                <md-spinner
                  md-indeterminate
                  id="loader"
                  style="display: none"
                ></md-spinner>
              </md-layout>
              <hr class="hr-s" />
            </div>

            <b-container fluid>
              <!-- User Interface controls -->
              <b-row>
                <b-col
                  :md="
                    SOAAccess == 'Yes' ||
                    $route.path == '/agentColoader/agentColoaderForm' ||
                    $sessionsStorage.get('nameUser') == 'Bhavneesh' ||
                    $sessionsStorage.get('cust_username') == 'admin'
                      ? 8
                      : 12
                  "
                  class="my-1"
                >
                  <b-form-group>
                    <b-input-group>
                      <b-form-input
                        :formatter="capitalizeAll"
                        v-model="filter"
                        placeholder="Type to Search"
                        @input="getData"
                      />
                      <b-input-group-append>
                        <b-button :disabled="!filter" @click="ClearFilter"
                          >Clear</b-button
                        >
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>
                <b-col
                  md="2"
                  v-if="
                    SOAAccess == 'Yes' ||
                    $route.path == '/agentColoader/agentColoaderForm' ||
                    $sessionsStorage.get('nameUser') == 'Bhavneesh' ||
                    $sessionsStorage.get('cust_username') == 'admin'
                  "
                >
                  <model-list-select
                    :list="categoryTypeList"
                    v-model="Type"
                    option-value="categoryTypeVal"
                    option-text="categoryTypeTxt"
                    placeholder="Select Type"
                    @input="getData"
                  ></model-list-select>
                </b-col>
                <b-col
                  md="2"
                  v-if="
                    SOAAccess == 'Yes' ||
                    $route.path == '/agentColoader/agentColoaderForm' ||
                    $sessionsStorage.get('nameUser') == 'Bhavneesh' ||
                    $sessionsStorage.get('cust_username') == 'admin'
                  "
                >
                  <model-list-select
                    :list="StatusTypeList"
                    v-model="Status"
                    option-value="StatusTypeVal"
                    option-text="StatusTypeTxt"
                    placeholder="Select Status"
                    @input="getData"
                  ></model-list-select>
                </b-col>
              </b-row>
              <b-row
                class="align-content-end mt-3"
                v-if="
                  SOAAccess == 'Yes' ||
                  $route.path == '/agentColoader/agentColoaderForm' ||
                  $sessionsStorage.get('nameUser') == 'Bhavneesh' ||
                  $sessionsStorage.get('cust_username') == 'admin'
                "
              >
                <b-col class="mb-1" cols="6">
                  <input
                    type="checkbox"
                    @click="SelectAll(allAgentColoaderData)"
                    v-model="isCheckAll"
                  />
                  <label>Select / Deselect All Count({{ this.AllAgentds.length }})</label>
                  <!-- <b-button
                    v-if="AllAgentds.length > 0"
                    size="sm"
                    @click="ShowModalAgentColoder"
                    variant="outline-primary"
                    class="ml-2"
                    >Send Email</b-button
                  > -->
                  <Send-Email
                    v-if="AllAgentds.length > 0"
                    :AgentId="AllAgentds"
                    :AllEmailId="AllEmailId"
                    :type="Type ? Type : 'Agent'"
                  ></Send-Email>
                </b-col>
                <b-col class="mb-1 pull-right" cols="6">
                  <h5 class="text-muted pull-right mt-2">
                    <small v-if="isLoading == false">{{ totalRows }} Entries</small>
                  </h5>
                </b-col>
              </b-row>
              <!-- Main table element -->
              <div class="table-responsive tableMain">
                <b-table
                  show-empty
                  stacked="md"
                  :items="allAgentColoaderData"
                  :fields="fields"
                  :current-page="currentPage"
                  :per-page="perPage"
                  :filter="filter"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  :sort-direction="sortDirection"
                  @filtered="onFiltered"
                >
                  <template slot="agntColoader" slot-scope="row0">
                    <input
                      type="checkbox"
                      v-bind:value="row0.item.agntColoaderId"
                      v-bind:id="row0.item.emailId"
                      v-model="AllAgentds"
                      @change="updateSelectAll($event, row0.item)"
                    />
                    <span>{{ row0.index + 1 + (currentPage - 1) * perPage }}</span>
                  </template>
                  <template slot="categoryType" slot-scope="row1">
                    <span
                      @click="
                        $sessionsStorage.get('designation') == 'Admin' &&
                        $sessionsStorage.get('nameUser') == 'Bhavneesh'
                          ? viewEdit(row1.item)
                          : ''
                      "
                      class="showMoreData"
                      >{{ row1.item.categoryType }}</span
                    ><br />
                    <b-button
                      class="mt-1"
                      v-if="row1.item.categoryType == 'Agent'"
                      id="show-btn"
                      size="xs"
                      style="font-size: 0.675rem"
                      variant="primary"
                      @click="goAgentPass(row1.item)"
                      >Update Agent Pass</b-button
                    ><br />
                    <b-button
                      class="mt-1"
                      v-if="row1.item.categoryType == 'Agent'"
                      id="show-btn"
                      size="xs"
                      style="font-size: 0.675rem"
                      variant="primary"
                      @click="showModal(row1.item)"
                      >Add Agent Factory</b-button
                    ><br />
                    <b-button
                      class="mt-1"
                      v-if="row1.item.categoryType == 'Agent'"
                      id="show-btn"
                      size="xs"
                      style="font-size: 0.675rem"
                      variant="primary"
                      @click="getAllFactory(row1.item)"
                      >View Agent Factory</b-button
                    >
                  </template>
                  <template slot="agentName" slot-scope="row11">
                    <span>{{
                      row11.item.agentName != "" ? row11.item.agentName : "--"
                    }}</span>
                  </template>
                  <template slot="coLoaderName" slot-scope="row12">
                    <span>{{
                      row12.item.coLoaderName != "" ? row12.item.coLoaderName : "--"
                    }}</span>
                  </template>
                  <template slot="contactNumber" slot-scope="row13">
                    <span>
                      Contact No. : {{ row13.item.contactNumber }}
                      <br />
                    </span>
                    <span>
                      Email : {{ row13.item.emailId }}
                      <br />
                    </span>
                  </template>
                  <template slot="agntColoaderId" slot-scope="row22">
                    <span
                      >Preference :
                      <b style="text-transform: capitalize">{{
                        row22.item.engagementPreference
                      }}</b></span
                    >
                    <div
                      v-if="adminToggle == 'Admin'"
                      :id="'row' + row22.item.agntColoaderId"
                    >
                      <md-switch
                        :id="'approval' + row22.item.agntColoaderId"
                        name="approval"
                        class="md-primary"
                        :value="row22.item.isACActive == 1 ? true : false"
                        @change="activateAgent(row22.item)"
                      >
                        <h6>
                          <br />
                          <b-badge style="margin-left: -45px">{{
                            row22.item.isACActive == 1 ? "Active" : "In-Active"
                          }}</b-badge>
                        </h6>
                      </md-switch>
                    </div>
                    <div v-else :id="'row' + row22.item.agntColoaderId">
                      <h6>
                        <b-badge>{{
                          row22.item.isACActive == 1 ? "Active" : "In-Active"
                        }}</b-badge>
                      </h6>
                    </div>
                  </template>
                  <template slot="companyName" slot-scope="row14">
                    <span>
                      Company Name : {{ row14.item.companyName }}
                      <br />
                    </span>
                    <span>
                      Address : {{ row14.item.address }}
                      <br />
                    </span>
                  </template>
                  <template slot="countryName" slot-scope="row45">
                    <span>{{ row45.item.countryName }}<br /></span>
                  </template>
                  <!-- <md-button
                            class="md-icon-button md-raised md-dense"
                            @click="deleteData(item1.containerTypeId)"
                          >
                            <md-icon>delete_sweep</md-icon>
                  </md-button>-->
                </b-table>
              </div>

              <b-row>
                <b-col md="12" class="my-1">
                  <b-pagination
                    :total-rows="totalRows"
                    :per-page="perPage"
                    v-model="currentPage"
                    class="my-0 pull-right"
                  />
                </b-col>
              </b-row>
            </b-container>
          </b-card-text>
        </b-card>
      </b-card-text>
    </b-card>

    <b-modal
      no-close-on-esc
      no-close-on-backdrop
      ref="Import-modal"
      hide-footer
      id="modal-multi-2"
      size="lg"
      title="Import Excel File"
    >
      <b-row>
        <b-col md="12">
          <md-input-container>
            <label>Upload File</label>
            <md-file
              name="excelUpload"
              id="excelUpload"
              v-model="excelUpload"
              @selected="onFileChange()"
              accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            ></md-file>
          </md-input-container>
        </b-col>
      </b-row>
    </b-modal>
    <!-- Additional Add User Client Modal Start -->
    <!-- <b-modal
      id="Agent_Coloder-modal"
      ref="Agent_Coloder-modal"
      title="Send Email"
      size="xl"
      centered
      no-close-on-esc
      no-close-on-backdrop
      hide-footer
    >
      <b-row>
        <b-col md="12">
          <label>To<span class="error"></span></label>
          <b-form-input
            :formatter="capitalizeAll"
            id="countryName"
            name="countryName"
            v-model="agentForm.to"
          ></b-form-input>
        </b-col>
        <b-col md="12">
          <label>CC<span class="error"></span></label>
          <b-form-input
            :formatter="capitalizeAll"
            id="countryName"
            name="countryName"
            v-model="agentForm.cc"
          ></b-form-input>
        </b-col>
        <b-col md="12">
          <label>
            BCC
            <span class="error"></span>
          </label>
          <b-form-input
            :formatter="capitalizeAll"
            id="countryName"
            name="countryName"
            v-model="agentForm.bcc"
          ></b-form-input>
        </b-col>
        <b-col md="12">
          <label>
            Subject
            <span class="error">*</span>
          </label>
          <b-form-input
            :formatter="capitalizeAll"
            id="countryName"
            name="countryName"
            v-model="agentForm.subject"
          ></b-form-input>
        </b-col>
        <b-col md="12">
          <label>
            Body
            <span class="error">*</span>
            <quill-editor
              style="
                width: 100% !important;
                height: 300px !important;
                background: #fff;
                display: inline-block;
              "
              v-model="agentForm.mailbody"
            ></quill-editor>
          </label>
        </b-col>
        <b-col md="12">
          <label>
            Doc
            <span class="error"></span>
          </label>
          <Single-Upload
            :disabled="agentColoder_inputFlag"
            :documentName="'agentForm_mail_doc_'"
            :otherDocName="'agentForm_mail_doc_'"
            :folderName="'Console_Booking_Doc'"
            :accept="'*'"
            :assign_no="`Console_Booking_Doc`"
            :multiple="true"
            v-model="agentForm.doc"
            :state="Boolean(agentForm.doc)"
            :fileAllModuleId="agentForm.subject"
          ></Single-Upload>
          <span
            v-if="
              agentForm.doc != '' && agentForm.doc != undefined && agentForm.doc != null
            "
          >
            <b v-if="agentForm.doc.split(',').length > 0">
              <span
                v-for="(item_doc, index_doc) in sanitizedArray(agentForm.doc.split(','))"
                :key="index_doc"
              >
                <a
                  v-if="item_doc != ''"
                  href="javascript:void(0)"
                  @click="ViewDocFile(item_doc)"
                  >View Document - {{ index_doc + 1 }}</a
                >
                <br />
              </span>
            </b>
            <b v-else>
              <a
                v-if="
                  agentForm.doc != '' &&
                  agentForm.doc != undefined &&
                  agentForm.doc != null
                "
                href="javascript:void(0)"
                @click="ViewDocFile(agentForm.doc)"
                >View Document</a
              >
            </b>
          </span>
        </b-col>
      </b-row>
      <b-button
        :disabled="agentForm.sendMail"
        @click="SendMail"
        variant="success"
        class="pull-right ml-2 mt-2"
        >Send
        <md-spinner v-if="agentForm.sendMail" md-indeterminate id="loader"></md-spinner
      ></b-button>
      <b-button @click="HideModalAgent" variant="danger" class="pull-right mt-2">
        Close</b-button
      >
    </b-modal> -->
    <!-- Additional Add User Client Modal End -->

    <b-modal
      no-close-on-esc
      no-close-on-backdrop
      size="xl"
      ref="Agent-Factory-modal"
      hide-footer
      :title="'Agent Factory List'"
    >
      <b-row>
        <b-col md="12">
          <div class="gutr" v-if="getAgentFactory.length > 0">
            <table id="factoryDetails" class="table table-bordered">
              <thead>
                <tr>
                  <th>SN</th>
                  <th>Factory Title</th>
                  <th>Factory Address</th>
                  <th>Factory GSTIN</th>
                  <th>Latitude</th>
                  <th>Longitude</th>
                  <th>Delete</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in getAgentFactory" :key="index">
                  <td>{{ index + 1 }}</td>
                  <td
                    v-if="item.enableEdit == '1'"
                    @click="EditFactory(item)"
                    class="showMoreData"
                  >
                    {{ item.factoryTitle }}
                  </td>
                  <td v-else>{{ item.factoryTitle }}</td>
                  <td>{{ item.factoryAddress1 }}</td>

                  <td>{{ item.GSTIN1 }}</td>
                  <td>{{ item.latitude }}</td>
                  <td>{{ item.longitude }}</td>
                  <td>
                    <md-button
                      class="md-icon-button md-raised md-dense"
                      @click="deleteData(item.multiFactoryId)"
                    >
                      <md-icon>delete_sweep</md-icon>
                    </md-button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </b-col>
        <b-col cols="12" class="text-center">
          <b-button
            class="mt-3"
            variant="outline-danger"
            size="xs"
            style="font-size: 0.675rem"
            @click="hideViewAgentFactoryModal"
            >Close</b-button
          >
        </b-col>
      </b-row>
    </b-modal>

    <b-modal ref="my-modal" hide-footer :title="agentDetails.agentName">
      <div class="d-block text-center">
        <h5>Agent Factory Details !</h5>
        <hr />

        <md-layout md-gutter>
          <md-layout md-flex="5"></md-layout>
        </md-layout>
        <md-layout md-gutter>
          <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="90">
            <md-layout md-flex="100">
              <label>Factory Title-Location]( e.g : Pridel Pvt Ltd-Delhi)</label>
              <b-form-input
                :formatter="capitalizeAll"
                name="factoryTitle"
                id="factoryTitle"
                v-model="factoryModal.factoryTitle"
              ></b-form-input>

              <span class="error" v-if="!factoryModal.factoryTitle">{{
                errorCustomValidation.factoryTitle
              }}</span>
            </md-layout>
          </md-layout>
        </md-layout>
        <md-layout md-gutter class="gutr">
          <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="90">
            <md-layout md-flex="100">
              <label>Address</label>
              <b-form-textarea
                :formatter="(value) => value.toUpperCase()"
                name="factoryAddress1"
                id="factoryAddress1"
                v-model="factoryModal.factoryAddress1"
              ></b-form-textarea>
              <span class="error" v-if="!factoryModal.factoryAddress1">{{
                errorCustomValidation.factoryAddress1
              }}</span>
            </md-layout>
          </md-layout>
        </md-layout>
        <md-layout md-gutter class="gutr">
          <div class="mt-2">
            <b-button
              :disabled="factoryModal.factoryAddress1 == '' ? true : false"
              class="pull-left ml-4"
              size="sm"
              variant="outline-info"
              @click="fetchLatLog"
              >Get Lat/Long</b-button
            >
          </div>
        </md-layout>

        <md-layout md-gutter class="gutr">
          <md-layout md-flex="5"></md-layout>

          <md-layout md-flex="45">
            <md-layout md-flex="100">
              <label>Latitude</label>
              <b-form-input
                :formatter="capitalizeAll"
                type="number"
                min="0"
                id="latitude"
                name="latitude"
                v-model="factoryModal.latitude"
              ></b-form-input>
            </md-layout>
          </md-layout>
          <md-layout md-flex="5"></md-layout>

          <md-layout md-flex="45">
            <md-layout md-flex="100">
              <label>Longitude</label>
              <b-form-input
                :formatter="capitalizeAll"
                type="number"
                min="0"
                id="latitude"
                name="latitude"
                v-model="factoryModal.longitude"
              ></b-form-input>
            </md-layout>
          </md-layout>
        </md-layout>
        <md-layout md-gutter class="gutr">
          <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="90">
            <md-layout md-flex="100">
              <label>GSTIN No</label>
              <b-form-input
                :formatter="capitalizeAll"
                name="GSTIN1"
                id="GSTIN1"
                v-model="factoryModal.GSTIN1"
              ></b-form-input>
            </md-layout>
          </md-layout>
        </md-layout>
      </div>
      <b-button class="mt-3" block variant="primary" @click="addFactory('', 'AddFactory')"
        >{{ factoryModal.multiFactoryId == "" ? "Add " : "Update " }}

        Factory
      </b-button>
      <b-button class="mt-3" variant="outline-danger" block @click="hideModal"
        >Close
      </b-button>
    </b-modal>
    <md-dialog-alert
      class="addpop-zindex"
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop"
    ></md-dialog-alert>
    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      @close="onCloseDelete"
      ref="addPopDeleteF"
    ></md-dialog-confirm>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
import moment from "moment";
import { ModelListSelect } from "vue-search-select";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../../helper/filters";
import { globalPermissionStatus } from "../../../helper/collection";
import SendEmail from "../../common/sendEmail.vue";
import ClientUserService from "../../../services/ClientUserService";
import CommonService from "../../../services/CommonService.js";
import CustomLoader from "../../common/customLoader.vue";
import PaymentRequestService from "../../../services/PaymentRequestService.js";
export default {
  beforeMount() {
    if (globalPermissionStatus("Main Master")) {
      this.$store.dispatch("setCurrentRoute", "/agentColoader/agentColoaderForm");
      this.getData();
    } else {
      // this.$router.push({
      //   path: "/common/agentColoader/"
      // });
      this.$store.dispatch("setCurrentRoute", "/common/agentColoader/");
      this.getData();
    }
    this.getOSAccesibaleUsers();
  },
  data() {
    return {
      deleteId: "",
      agentDetails: {},
      factoryModal: {
        longitude: "",
        latitude: "",
        agent_id: "",
        multiFactoryId: "",
        agentId: "",
        location: "",
        GSTIN1: "",
        factoryAddress1: "",
        factoryTitle: "",
      },

      getAgentFactory: [],
      // Custom Validation Variable Declaration Start 20/11/2023
      errorCustomValidation: {
        factoryAddress1: "",
        factoryTitle: "",
      },

      arrayErrorCustomValidation: [
        {
          factoryAddress1: "Please Enter Factory Address ",
          factoryTitle: "Please Enter Factory Title",
        },
      ],
      // Custom Validation Variable Declaration End 20/11/2023

      SOAAccess: "No",
      docURL: URL_BASE_DOC,
      agentColoder_inputFlag: false,
      isCheckAll: false,
      AllAgentds: [],
      AllEmailId: [],
      selectedAllAgentds: "",
      selectedEmailId: "",
      agentForm: {
        sendMail: false,
        mail_id: "",
        cc: "",
        bcc: "",
        to: "",
        previousto: "",
        subject: "",
        mailbody: "",
        doc: "",
      },

      fields: [
        {
          key: "agntColoader",
          label: "SN.",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "categoryType",
          label: "Category Type",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "agentName",
          label: "Agent Name",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "coLoaderName",
          label: "Co-Loader Name",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "companyName",
          label: "Company Details",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "contactNumber",
          label: "Contact Details",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "countryName",
          label: "Country",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "agntColoaderId",
          label: "Preference/Status",
          sortable: true,
          sortDirection: "desc",
          class: "text-center",
        },
      ],
      excelUpload: "",
      ExcelBtnName: "Export as Excel",
      currentPage: 1,
      perPage: 10,
      totalRows: "",
      adminToggle: this.$sessionsStorage.get("designation"),
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      sortDirection: "desc",
      filter: null,
      Type: "",
      Status: "2",
      StatusTypeList: [
        {
          StatusTypeVal: "0",
          StatusTypeTxt: "In-Active",
        },
        {
          StatusTypeVal: "1",
          StatusTypeTxt: "Active",
        },
        {
          StatusTypeVal: "2",
          StatusTypeTxt: "All",
        },
      ],
      modalInfo: { title: "", content: "" },
      alert: {
        content:
          this.$sessionsStorage.get("editRefuelId") != "" &&
          this.$sessionsStorage.get("editRefuelId") != undefined
            ? "Data Updated Succesfully"
            : "Added Succesfully",
        ok: "ok",
      },
      showMain: false,
      allAgentColoaderData: ["sas"],
      agentColaderModel: {
        categoryType: "",
        agntColoaderId: "",
        agentName: "",
        coLoaderName: "",
        contactNumber: "",
        countryName: "",
        emailId: "",
        companyName: "",
        address: "",
        engagementPreference: "Default",
      },
      categoryTypeList: [
        {
          categoryTypeVal: "Agent",
          categoryTypeTxt: "Agent",
        },
        {
          categoryTypeVal: "CoLoader",
          categoryTypeTxt: "CoLoader",
        },
        {
          categoryTypeVal: "CHA",
          categoryTypeTxt: "CHA",
        },
        {
          categoryTypeVal: "IATA",
          categoryTypeTxt: "IATA",
        },

        {
          categoryTypeVal: "Consignee",
          categoryTypeTxt: "Consignee",
        },
      ],
      engagementPreferenceList: [
        {
          engagementTypeVal: "Default",
          engagementTypeTxt: "Default",
        },
        {
          engagementTypeVal: "Preference 1",
          engagementTypeTxt: "Preference 1",
        },
        {
          engagementTypeVal: "Preference 2",
          engagementTypeTxt: "Preference 2",
        },
        {
          engagementTypeVal: "None",
          engagementTypeTxt: "None",
        },
      ],
      isLoading: true,
      editVar: {
        Inputval:
          this.$sessionsStorage.get("editRefuelId") != "" &&
          this.$sessionsStorage.get("editRefuelId") != undefined
            ? "Update"
            : "Add",
        FormVal:
          this.$sessionsStorage.get("editRefuelId") != "" &&
          this.$sessionsStorage.get("editRefuelId") != undefined
            ? "Update"
            : "New",
      },

      validate: true,
      categoryTypeError: "",
    };
  },

  mounted() {
    //this.JqueryFun();
  },
  beforeDestroy() {},
  destroyed() {},
  components: {
    DatePicker,
    ModelListSelect,
    Loading,
    SendEmail,
    CustomLoader,
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => {
          return { text: f.label, value: f.key };
        });
    },
  },
  created() {
    eventBus.$on("sendMailID", (sendMailID) => {
      console.log("sendMailID=>", sendMailID);
      if (sendMailID.mail_id > 0) {
        this.$refs["addPop"].open();
      } else {
        this.$refs["addPop"].open();
      }
      this.alert.content = sendMailID.MSG;
      this.getData();
    });
  },
  methods: {
    getOSAccesibaleUsers() {
      this.SOAAccess = "No";
      let payload = {
        itemCode: "OSAccesibaleUsers",
        departmentName: "Overseas Agent Assignments",
        departmentPageName:
          "FCL Export,FCL Con Export,FCL Import,Agent_SOA,Other_Overseas",
      };

      payload = JSON.stringify(payload);
      console.log("payload=>", payload);
      // return false;

      ClientUserService.getAllOverseaLock(payload)
        .then((response) => {
          const { data, status, statusText } = response;
          console.log("data=>", data);
          if (status == 200) {
            this.SOAAccess = data.SOAAccess;
          }
          this.isLoading = false;
        })
        .catch((error) => {
          console.log("Catch on OSAccesibaleUsers Error: ", error);
        });
    },
    ShowImportModal() {
      this.$refs["Import-modal"].show();
    },
    hideModalLoc() {
      this.$refs["Import-modal"].hide();
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    goToMain() {
      this.showMain = true;
    },
    clearAgentFact() {
      this.factoryModal = {
        longitude: "",
        latitude: "",

        multiFactoryId: "",
        agentId: "",
        location: "",
        GSTIN1: "",
        factoryAddress1: "",
        factoryTitle: "",
      };
    },
    goAgentPass(item) {
      
      this.$router.push({
        path: "/agent/user/upsertAgentUser/"+item.agntColoaderId,
      });
    },
    showModal(item) {
      this.clearAgentFact();
      this.agentDetails = item;
      this.factoryModal.agentId = item.agntColoaderId;
      this.$refs["my-modal"].show();
    },
    hideModal() {
      this.agentDetails = {};
      this.factoryModal.agentId = 0;
      this.$refs["my-modal"].hide();
    },
    EditFactory(item) {
      this.$refs["my-modal"].show();
      Object.keys(this.factoryModal).map((x) => {
        this.factoryModal[x] = item[x] || "";
      });
      this.factoryModal.agentId = this.factoryModal.agent_id;
    },
    fetchLatLog() {
      let options = {
        method: "GET",
        url:
          // `https://www.mapquestapi.com/geocoding/v1/address?key=OTLGZmcN6qXiHnH4qSU4lXTYWLPEoINP&location=` +
          `https://www.mapquestapi.com/geocoding/v1/address?key=AiBjJ4PC52j31H0BO1xlTTXDHIAZwDD0&location=` +
          this.factoryModal.factoryAddress1,
      };

      axios(options)
        .then((result) => {
          console.log(result.data.results[0].locations[0].displayLatLng);
          this.factoryModal.latitude =
            result.data.results[0].locations[0].displayLatLng.lat;
          this.factoryModal.longitude =
            result.data.results[0].locations[0].displayLatLng.lng;
        })
        .catch((error) => {});
    },
    onCloseDelete(type) {
      if (type != "cancel") {
        let paylod = {
          tableName: "client_multi_factory",
          tableId: "multiFactoryId",
          tableIsActive: "isMultifactoryActive",
          tableVal: this.deleteId,
        };
        let options = {
          method: "POST",
          url: `${URL_BASE}/deleteData.php`,
          data: JSON.stringify(paylod),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };
        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              this.JqueryFun();
              this.getAllFactory(this.agentDetails);
              // console.log(data);
            }
          })
          .catch((error) => {});
      }
    },
    deleteData(id) {
      this.deleteId = id;
      this.alert.content = "Are you sure you want to delete this data?";
      this.$refs["addPopDeleteF"].open();
    },
    validateAgentFactoryCustomVali() {
      let validate_new = true;
      Object.keys(this.errorCustomValidation).map((x, index) => {
        if (
          this.factoryModal[x] == "" ||
          this.factoryModal[x] == 0 ||
          this.factoryModal[x] == undefined ||
          this.factoryModal[x] == null ||
          this.factoryModal[x] == "undefined" ||
          this.factoryModal[x] == "null"
        ) {
          this.errorCustomValidation[x] = this.arrayErrorCustomValidation[0][x];
          if (x == "factoryAddress1" || x == "factoryTitle") {
            validate_new = false;
          }
        }
      });

      if (validate_new == true) {
        this.validate = true;
      } else {
        this.validate = false;
      }
    },
    addFactory(id, AddType) {
      this.validateAgentFactoryCustomVali();

      if (
        this.validate != false &&
        this.agentDetails.categoryType == "Agent" &&
        this.agentDetails.agntColoaderId >= 0
      ) {
        this.isLoading = true;
        let payload = {
          agentDetails: this.agentDetails,
          factoryModal: this.factoryModal,
          AddType: AddType,
          itemCode: "addAgentFactory",
        };

        CommonService.getAllJobList(payload)
          .then((response) => {
            const { data, status, statusText } = response;
            console.log();
            if (status == 200 && data.AddAgentFLAG == 1) {
            }
            this.alert.content = data.AddAgentMSG;
            this.$refs["addPop"].open();
            this.isLoading = false;
          })
          .catch((error) => {
            console.log("Catch on addAgentFactory Error: ", error);
          });
      }
    },
    hideViewAgentFactoryModal() {
      this.agentDetails = {};
      this.factoryModal.agentId = 0;
      this.$refs["Agent-Factory-modal"].hide();
    },
    getAllFactory(item) {
      this.agentDetails = item;
      this.getAgentFactory = [];
      if (item.agntColoaderId > 0) {
        this.$refs["Agent-Factory-modal"].show();
        this.isLoading = true;
        let payload = {
          agentId: item.agntColoaderId,
          itemCode: "getAgentFactory",
        };

        CommonService.getAllJobList(payload)
          .then((response) => {
            const { data, status, statusText } = response;
            console.log();
            if (status == 200 && data.getAgentFLAG == 1) {
              this.getAgentFactory = data.getAgentFactory;
            }
            this.isLoading = false;
          })
          .catch((error) => {
            console.log("Catch on getAgentFactory Error: ", error);
          });
      }
    },
    viewEdit(item1) {
      this.showMain = true;

      let arrayFilter = this.allAgentColoaderData.filter((x) => {
        return x.agntColoaderId == item1.agntColoaderId;
      });
      if (arrayFilter.length > 0) {
        Object.keys(this.agentColaderModel).map((x) => {
          this.agentColaderModel[x] = arrayFilter[0][x] || "";
        });
      }
    },
    JqueryFun() {
      return $(function () {
        return $("#agentCo12").DataTable();
      });
    },
    onClose(type) {
      //   this.$router.push({
      //     path: "/vendorMaster/viewVendorMaster"
      //   });
    },
    previousVendorView() {
      //   this.$router.push({
      //     path: "/vendorMaster/viewVendorMaster"
      //     // params:{
      //     //   "userId":res.data.Id,
      //     // }
      //   });
    },

    expandEvent(e) {
      e.preventDefault();
    },

    validateRefuelStation() {
      let validate_new = true;

      if (this.agentColaderModel.categoryType == "") {
        $("#categoryType").focus();
        this.categoryTypeError = "Select Category";
        validate_new = false;
      }

      if (validate_new != true) {
        this.validate = false;
      } else {
        this.validate = true;
      }
    },
    async activateAgent(item) {
      if (item && item.categoryType === "Consignee") {
        await this.toggleConsigneeStatusFromList(item);
        return;
      }
      item.isACActive = item.isACActive == 1 ? 0 : 1;
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Master/activateAgent.php`,
        data: JSON.stringify(item),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            console.log(data);
          }
        })
        .catch((error) => {});
    },
    async toggleConsigneeStatusFromList(item) {
      if (!item) return;
      const previousStatus = Number(item.isACActive) === 1 ? 1 : 0;
      const desiredStatus = previousStatus === 1 ? 0 : 1;
      const agntColoaderId = Number(item.agntColoaderId);

      if (!agntColoaderId || agntColoaderId <= 0) {
        this.alert.content = "Invalid Consignee ID. Please provide a valid agntColoaderId.";
        this.$refs["addPop"].open();
        item.isACActive = previousStatus;
        return;
      }

      item.isACActive = desiredStatus;

      try {
        const payload = {
          agntColoaderId,
          isActive: desiredStatus,
          categoryType: item.categoryType || "Consignee",
        };
        const response = await PaymentRequestService.deleteConsignee(payload);
        const { data, status } = response || {};
        const success = status === 200 && data && data.status !== false;
        if (!success) {
          throw new Error(
            (data && (data.message || data.msg)) || "Failed to update consignee status."
          );
        }
        this.alert.content = data.message || data.msg || "Status updated successfully.";
        this.$refs["addPop"].open();
        this.getData();
      } catch (error) {
        console.error("toggleConsigneeStatusFromList error", error);
        item.isACActive = previousStatus;
        this.alert.content =
          (error && error.message) || "An error occurred while updating the status.";
        this.$refs["addPop"].open();
      }
    },
    addAgentColoader() {
      this.validateRefuelStation();
      if (this.validate != false) {
        $("#addButtonLoader").css("display", "none");
        $("#loader").css("display", "block");
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_FFSeaExport/addAgentColoader.php`,
          data: JSON.stringify(this.agentColaderModel),
          crossDomain: true,

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };

        axios(options)
          .then((result) => {
            if ((result.data.msg = "Inserted Successfully")) {
              Object.keys(this.agentColaderModel).map((x) => {
                this.agentColaderModel[x] = "";
              });
            }

            $("#addButtonLoader").css("display", "block");
            $("#loader").css("display", "none");
            this.$refs["addPop"].open();
            this.getData();
            this.showMain = false;
          })

          .catch((error) => {});
      }
    },
    ClearFilter() {
      this.Type = "";
      this.Status = "2";
      this.filter = "";
      this.allAgentColoaderData = [];
      this.totalRows = 0;
      this.getData();
    },
    getData() {
      this.isLoading = true;
      this.allAgentColoaderData = [];
      this.totalRows = 0;
      let type_Size = {
        categoryType: "categoryType",
        Type: this.Type,
        Status:
          this.$route.path == "/agentColoader/agentColoaderForm"
            ? this.Status
              ? this.Status
              : ""
            : "1",
      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_FFSeaExport/fetchtoAgentColoader.php`,
        data: JSON.stringify(type_Size),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            if (data.agentCoLoaderTable.length > 0) {
              this.allAgentColoaderData = data.agentCoLoaderTable;
              this.totalRows = data.agentCoLoaderTable.length;
            }
            //    console.log(this.allAgentColoaderData);

            this.isLoading = false;
            this.JqueryFun();
          }
        })
        .catch((error) => {});
    },
    // Added By Priyanshu Singh Start

    getReportsAss(id, btnName) {
      let excelIdGivin = "";
      if (id == "All_AgentColoder_Report") {
        excelIdGivin = "All_AgentColoder_Report";
      }
      let payload = {
        excelId: excelIdGivin,
        assignmentNo: "Consignee",
      };
      this.ExcelBtnName = "Downloading Please Wait...";
      this.$store.dispatch(
        "common/setAllPendingReverseTallyExcel",
        JSON.stringify(payload)
      );
      let ExcelName = "";
      this.ExcelBtnName = btnName;
      if (this.$store.getters["common/getAllPendingReverseTallyExcel"]) {
        ExcelName = this.$store.getters["common/getAllPendingReverseTallyExcel"];
      }
    },
    // Added By Priyanshu Singh Start
    onFileChange() {
      var files = event.target.files || event.dataTransfer.files;
      // this.uploadCheck = files[0];
      var formData = new FormData();
      for (let i = 0; i < files.length; i++) {
        formData.append(`AgentColoaderMaster[]`, files[i]);
      }
      const config = {
        headers: { "content-type": "multipart/form-data" },
      };
      axios
        .post(`${URL_BASE}/uploadExcelDataMaster.php`, formData, config)
        .then((result) => {
          console.log(result.data);
          if (result.data == "Only XLXS Format Support") {
            this.alert.content = "Only .xlxs format support";
          } else {
            this.alert.content = result.data;
          }
          this.$refs["addPop"].open();
        })
        .catch((err) => {
          throw err;
        });
    },
    SelectAll: function () {
      console.log("this.User List=>", this.allAgentColoaderData);
      this.isCheckAll = !this.isCheckAll;
      this.AllAgentds = [];
      this.AllEmailId = [];
      if (this.isCheckAll) {
        // Check all
        for (var key in this.allAgentColoaderData) {
          let single_data = "";
          this.AllAgentds.push(this.allAgentColoaderData[key].agntColoaderId);
          this.AllEmailId.push(this.allAgentColoaderData[key].emailId);
        }
        console.log("this.AllAgentds=>", this.AllAgentds);
        console.log("this.AllEmailId=>", this.AllEmailId);
      }
    },
    updateSelectAll: function (e, item) {
      console.log("ids", e);
      console.log("ids", item);
      if (this.AllAgentds.length == this.allAgentColoaderData.length) {
        this.isCheckAll = true;
      } else {
        this.isCheckAll = false;
      }
      const istrue = this.AllAgentds.includes(item.agntColoaderId);
      if (istrue == true) {
        this.AllEmailId.push(item.emailId);
      } else {
        const index = this.AllEmailId.indexOf(item.emailId);
        this.AllEmailId.splice(index, 1);
      }

      console.log("this.AllAgentds=>", this.AllAgentds);
      console.log("this.AllEmailId=>", this.AllEmailId);
    },
  },
};
</script>
<style>
.md-direction-bottom-right {
  width: 16% !important;
}
.mrgtop-2per {
  margin-top: 1%;
}
.mrgtop-5px {
  margin-top: 0px;
}
.center {
  text-align: center;
}
.heght-1px {
  height: 1px;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}
.md-button-color {
  background-color: #607d8d !important;
}

.md-button-color-toggle {
  background-color: rgba(153, 153, 153, 0.4) !important;
}

.activeClass {
  display: none;
}
.error {
  color: red;
}
.addpop-zindex {
  z-index: 20000;
}
</style>



// WEBPACK FOOTER //
// agentColoaderForm.vue?20557c8e